import React from 'react';

import { Separator } from 'kards-components';

export default ({ component }) => <Separator data={component.value} />;
